import { useEffect, useRef, useState } from 'react';

export const usePerformance = () => {
    const [fps, setFps] = useState<number>(0);

    const frame = useRef<number>();
    const frameCount = useRef<number>(0);
    const last = useRef(performance.now());

    const animate = () => {
        frameCount.current++;
        const now = performance.now();
        const delta = (now - last.current) / 1000;
        if (delta >= 1) {
            const fps: number = Math.floor(frameCount.current / delta); // Calculate FPS
            frameCount.current = 0;
            last.current = now;
            setFps(fps);
        }
        frame.current = requestAnimationFrame(animate);
    };

    useEffect(() => {
        frame.current = requestAnimationFrame(animate);
        return () => {
            frame.current && cancelAnimationFrame(frame.current);
        };
    }, []);

    return { fps };
};
